import { render } from "./algorithmSections.vue?vue&type=template&id=74fd00b7"
import script from "./algorithmSections.vue?vue&type=script&lang=js"
export * from "./algorithmSections.vue?vue&type=script&lang=js"

import "./algorithmSections.vue?vue&type=style&index=0&id=74fd00b7&scoop=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__